import { render, staticRenderFns } from "./preguntas.vue?vue&type=template&id=429f7ce4&"
import script from "./preguntas.vue?vue&type=script&lang=js&"
export * from "./preguntas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports